module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert J. Richards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robert J. Richards")]), _vm._v(" is the Morris Fishbein Professor of the History of Science and Medicine at the University of Chicago and the author, most recently, of "), _c('I', [_vm._v("The Romantic Conception of Life: Science and Philosophy in the Age of Goethe")]), _vm._v(", also published by the University of Chicago Press.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wr36V7/tc-custom/9780226712192.jpg?1728259609204",
      "alt": "This image is the cover for the book Tragic Sense of Life"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tragic Sense of Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Prior to the First World War, more people learned of evolutionary theory from the voluminous writings of Charles Darwin’s foremost champion in Germany, Ernst Haeckel (1834–1919), than from any other source, including the writings of Darwin himself. But, with detractors ranging from paleontologist Stephen Jay Gould to modern-day creationists and advocates of intelligent design, Haeckel is better known as a divisive figure than as a pioneering biologist. Robert J. Richards’s intellectual biography rehabilitates Haeckel, providing the most accurate measure of his science and art yet written, as well as a moving account of Haeckel’s eventful life.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0